import { ScrollShadow } from '@heroui/react'

interface ProductImagesProps {
  images: Array<string | undefined>
  selectedImage?: string
  onSelectImage: (src: string) => void
}

export const ProductImages = ({
  images,
  selectedImage,
  onSelectImage
}: ProductImagesProps) => {
  return (
    <div className="flex h-[62vw] w-full gap-2 md:h-auto md:max-h-full md:w-fit md:flex-row-reverse">
      <div className="size-full max-w-[26rem]">
        <img
          src={selectedImage}
          className="size-full max-h-full rounded-md object-cover md:h-auto md:w-[26rem]"
          width={416}
          height={519}
          alt=""
          loading="eager"
        />
      </div>
      <ScrollShadow
        as="ul"
        className="flex h-full shrink-0 flex-col gap-2 overflow-y-auto overflow-x-hidden"
      >
        {images.map((img) =>
          img ? (
            <li
              key={img}
              className="size-28 shrink-0 overflow-hidden hover:brightness-[0.85] md:size-16"
              onMouseEnter={() => onSelectImage(img)}
            >
              <img
                src={img}
                className="size-full rounded-md object-cover"
                width={64}
                height={64}
                alt=""
                loading="lazy"
              />
            </li>
          ) : null
        )}
      </ScrollShadow>
    </div>
  )
}
